function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ((useActualHostSelector ? ":host {" : hostSelector + " {")) + "display: block;}.recommendation-card" + shadowSelector + " wds-listing-card" + shadowSelector + " {display: block;height: 100%;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];